import createApi from '@/services/Api';
import moment from 'moment';
import { log } from '@/utils/logger';

function UserMonitoring() {
  const api = createApi(),
    endpoint = `/profissional-saude/profissionais/monitoramentos`,
    mouseStopDelay = 1000;
  let timeout;

  const dispatchLifeSign = ({ detail }) => {
    log('UserMonitoring data sent: ', detail);
    api.post(endpoint, detail);
  };

  const dispatchMouseStop = evt => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      const event = new CustomEvent('mousestop', {
        detail: {
          dataHora: moment().format('DD/MM/YYYY kk:mm'),
          eixoX: evt.clientX,
          eixoY: evt.clientY,
        },
        bubbles: true,
      });

      evt.target.dispatchEvent(event);
    }, mouseStopDelay);
  };

  const bindEvents = () => {
    document.addEventListener('mousemove', dispatchMouseStop);
    document.addEventListener('mousestop', dispatchLifeSign);
  };

  const unbindEvents = () => {
    document.removeEventListener('mousemove', dispatchMouseStop);
    document.removeEventListener('mousestop', dispatchLifeSign);
  };

  const stop = () => {
    unbindEvents();
    clearTimeout(timeout);
  };

  const init = () => {
    clearTimeout(timeout);
    bindEvents();
  };

  return {
    init,
    stop,
  };
}

export default UserMonitoring();
